'use client'

import { useEffect, useState } from 'react'
import { useRouter } from 'next/navigation'

import { useAuthContext } from '@/app/firebase/AuthContext'
import { ReportShellSkeleton } from '@/components/loaders/report-shell-skeleton'
import { getFirstSidebarReportPath } from '@/lib/firestore/user-aio-reports'

export const RedirectToFirstReportIfAuthed = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { user } = useAuthContext()
  const router = useRouter()
  const [shouldStay, setShouldStay] = useState(false)

  useEffect(() => {
    const uid = user?.uid
    if (!uid) {
      setShouldStay(false)
      return
    }

    let cancelled = false
    setShouldStay(false)

    const redirectToFirstReport = async () => {
      try {
        const path = await getFirstSidebarReportPath(uid)
        if (cancelled) return
        if (path) {
          router.replace(path)
          return
        }
        setShouldStay(true)
      } catch {
        if (!cancelled) setShouldStay(true)
      }
    }

    void redirectToFirstReport()
    return () => {
      cancelled = true
    }
  }, [router, user?.uid])

  if (user?.uid && !shouldStay) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <ReportShellSkeleton className="max-w-md" aria-label="Loading report" />
      </div>
    )
  }

  return <>{children}</>
}
